import * as Sentry from "@sentry/react";

export const setSentryBackendChannelContext = settings => {
  const backendChannel = settings?.backendChannel || "default";

  Sentry.setTag("backendChannel", backendChannel);
};
